<div class="container" *ngIf="finderData && finderData.admin">
  <div class="row">
    <div class="col-12 search-admin">
      <button type="button" class="btn btn-lg danger mr-2"
        *ngIf="finderData.admin && finderData.admin.searchTags && finderData.admin.searchTags.length > 0 && _classificationService.active !== true"
        (click)='removeSearchTagsAdmin(true)'><span i18n="finder_admin|@@clear" style="color: white;">Clear</span></button>
      <button class="btn btn-lg secondary mr-2" (click)="showDropdown()"><img
          src="../../../assets/icon/filter-results-button.svg"></button>
      <div class="dropdown" id="dropdownadmin">
        <div class="dropdown-content">
          <div class="container">
            <div class="row pt-2 pb-2  vertical-align">
              <div class="col-4">
                <span i18n="finder_admin|@@limit" class="title">Limite </span>
              </div>
              <div class="col-8">
                <form>
                  <input (change)="onChange($event)" min="15" type="number" placeholder="15" [formControl]="limit">
                </form>
              </div>
            </div>
            <div class="row pt-2 pb-2  vertical-align">
              <div class="col-4">
                <span i18n="finder_admin|@@hdScan" class="title">Scan HD </span>
              </div>
              <div class="col-4">
                <label class="checkbox-container">
                  <input type="checkbox" [(ngModel)]="finderData.admin.hd.hd" (ngModelChange)="onChange($event)">
                  <span i18n="finder_admin|@@hdScan" class="checkmark"></span>Scan HD</label>
              </div>
              <div class="col-4">
                <label class="checkbox-container">
                  <input type="checkbox" [(ngModel)]="finderData.admin.hd.nHd" (ngModelChange)="onChange($event)">
                  <span i18n="finder_admin|@@nonHd" class="checkmark"></span>Scan Non HD</label>
              </div>
            </div>
            <div class="row pt-2 pb-2  vertical-align">
              <div class="col-4">
                <span i18n="finder_admin|@@scanExtract" class="title">Scan extract HD </span>
              </div>
              <div class="col-4">
                <label class="checkbox-container">
                  <input type="checkbox" [(ngModel)]="finderData.admin.xhd.xhd" (ngModelChange)="onChange($event)">
                  <span i18n="finder_admin|@@scanExtract" class="checkmark"></span>Scan extract HD</label>
              </div>
              <div class="col-4">
                <label class="checkbox-container">
                  <input type="checkbox" [(ngModel)]="finderData.admin.xhd.nxHd" (ngModelChange)="onChange($event)">
                  <span i18n="finder_admin|@@nonScanExtract" class="checkmark"></span>Scan Non extract HD</label>
              </div>
            </div>
            <div class="row pt-2 pb-2  vertical-align">
              <div class="col-4">
                <span i18n="finder_admin|@@annotatedScan" class="title">Scan annoté </span>
              </div>
              <div class="col-4 ">
                <label class="checkbox-container">
                  <input type="checkbox" [(ngModel)]="finderData.admin.note.note" (ngModelChange)="onChange($event)">
                  <span i18n="finder_admin|@@annotatedScan" class="checkmark"></span>Scan annoté</label>
              </div>
              <div class="col-4">
                <label class="checkbox-container">
                  <input type="checkbox" [(ngModel)]="finderData.admin.note.nNote" (ngModelChange)="onChange($event)">
                  <span i18n="finder_admin|@@nonAnnotated" class="checkmark"></span>Scan Non annoté</label>
              </div>
            </div>
            <div class="row pt-2 pb-2  vertical-align">
              <div class="col-8">
                <span i18n="finder_admin|@@searchByAnnotation" class="title">Recherche par annotations</span>
              </div>
              <div class="col-4">
                <div class="parameters-toggle">
          <app-generic-toggle  (sendData)="finderData.admin.annotateSearch = $event; onChangeShow('annotate', $event)" [value]="finderData.admin.annotateSearch" ></app-generic-toggle>
                </div>
              </div>
            </div>
            <div *ngIf="finderData.admin && finderData.admin.annotateSearch">
              <div class="row pt-2 pb-2  vertical-align">
                <div class="col-4">
                  <span i18n="finder_admin|@@together" class="title">Ensemble </span>
                </div>
                <div class="col-4">
                  <app-select-dropdown (onSave)="editListCheckbox($event)"
                    [list]="finderData.admin.searchTagList.typeTag" [title]="'Inclus'"></app-select-dropdown>
                </div>
                <div class="col-4">
                  <app-select-dropdown (onSave)="editListCheckbox($event)"
                    [list]="finderData.admin.searchTagList.nTypeTag" [title]="'Non inclus'"></app-select-dropdown>
                  <div class="add-one">
                    <img src="../../../assets/icon/plus.svg">
                  </div>
                </div>
              </div>
              <div class="row pt-2 pb-2  vertical-align">
                <div class="col-4">
                  <span i18n="finder_admin|@@classes" class="title">Classes</span>
                </div>
                <div class="col-4">
                  <app-select-dropdown (onSave)="editListCheckbox($event)"
                    [list]="finderData.admin.searchTagList.classTag" [title]="'Incluses'"></app-select-dropdown>
                </div>
                <div class="col-4">
                  <app-select-dropdown (onSave)="editListCheckbox($event)"
                    [list]="finderData.admin.searchTagList.nClassTag" [title]="'Non incluses'"></app-select-dropdown>
                  <div class="add-one">
                    <img src="../../../assets/icon/plus.svg">
                  </div>
                </div>
              </div>
              <div class="row pt-2 pb-2  vertical-align">
                <div class="col-4">
                  <span i18n="finder_admin|@@attributs" class="title">Attributs</span>
                </div>
                <div class="col-4">
                  <app-select-dropdown (onSave)="editListCheckbox($event)"
                    [list]="finderData.admin.searchTagList.attributesTag" [title]="'Incluses'"></app-select-dropdown>
                </div>
                <div class="col-4">
                  <app-select-dropdown (onSave)="editListCheckbox($event)"
                    [list]="finderData.admin.searchTagList.nAttributesTag" [title]="'Non incluses'">
                  </app-select-dropdown>
                  <div class="add-one">
                    <img src="../../../assets/icon/plus.svg">
                  </div>
                </div>
              </div>
              <div class="row pt-2 pb-2  vertical-align">
                <div class="col-4">
                  <span i18n="finder_admin|@@trackDetection" class="title">Détection piece</span>
                </div>
                <div class="col-4">
                  <app-select-dropdown (onSave)="editListCheckbox($event)" [list]="list" [title]="'Incluses'">
                  </app-select-dropdown>
                </div>
                <div class="col-4">
                  <app-select-dropdown (onSave)="editListCheckbox($event)" [list]="list" [title]="'Non incluses'">
                  </app-select-dropdown>
                  <div class="add-one">
                    <img src="../../../assets/icon/plus.svg">
                  </div>
                </div>
              </div>
              <div class="row pt-2 pb-2  vertical-align">
                <div class="col-4">
                  <span i18n="finder_admin|@@classDetection" class="title">Détection classes</span>
                </div>
                <div class="col-4">
                  <app-select-dropdown (onSave)="editListCheckbox($event)" [list]="list" [title]="'Incluses'">
                  </app-select-dropdown>
                </div>
                <div class="col-4">
                  <app-select-dropdown (onSave)="editListCheckbox($event)" [list]="list" [title]="'Non incluses'">
                  </app-select-dropdown>
                  <div class="add-one">
                    <img src="../../../assets/icon/plus.svg">
                  </div>
                </div>
              </div>
              <div class="row pt-2 pb-2  vertical-align"
                *ngIf="currentId === 'GO0ULtsopn' || currentId === 'YV9HNI8yM1' || currentId === '2sNbXqKToz'">
                <div class="col-4">
                  <span i18n="finder_admin|@@user" class="title">User</span>
                </div>
                <div class="col-4">
                  <app-select-dropdown (onSave)="editListCheckbox($event)"
                    [list]="finderData.admin.searchTagList.userAnnotateTag" [title]="'Incluses'">
                  </app-select-dropdown>
                </div>
                <div class="col-4">
                  <app-select-dropdown (onSave)="editListCheckbox($event)"
                    [list]="finderData.admin.searchTagList.nUserAnnotateTag" [title]="'Non incluses'">
                  </app-select-dropdown>
                  <div class="add-one">
                    <img src="../../../assets/icon/plus.svg">
                  </div>
                </div>
              </div>
            </div>
            <div class="row pt-2 pb-2  vertical-align">
              <div class="col-8">
                <span i18n="finder_admin|@@searchByDamages" class="title">Recherche par Dommages</span>
              </div>
              <div class="col-4">
                <div class="parameters-toggle">
          <app-generic-toggle  (sendData)="finderData.admin.damageSearch = $event; onChangeShow('damage', $event)" [value]="finderData.admin.damageSearch" ></app-generic-toggle>
                </div>
              </div>
            </div>
            <div *ngIf="finderData.admin.damageSearch">
              <div class="row pt-2 pb-2  vertical-align">
                <div class="col-4">
                  <span i18n="finder_admin|@@damagesDetection" class="title">Détection dommages</span>
                </div>
                <div class="col-4">
                  <app-select-dropdown (onSave)="editListCheckbox($event)"
                    [list]="finderData.admin.searchTagList.damageTag" [title]="'Inclus'"></app-select-dropdown>
                </div>
                <div class="col-4">
                  <app-select-dropdown (onSave)="editListCheckbox($event)"
                    [list]="finderData.admin.searchTagList.nDamageTag" [title]="'Non inclus'"></app-select-dropdown>
                </div>
              </div>
              <div class="row pt-2 pb-2  vertical-align">
                <div class="col-4">
                  <span i18n="finder_admin|@@modifications" class="title">Modifications</span>
                </div>
                <div class="col-4">
                  <app-select-dropdown (onSave)="editListCheckbox($event)"
                    [list]="finderData.admin.searchTagList.editDamageTag" [title]="'Incluses'"></app-select-dropdown>
                </div>
                <div class="col-4">
                  <app-select-dropdown (onSave)="editListCheckbox($event)"
                    [list]="finderData.admin.searchTagList.nEditDamageTag" [title]="'Non incluses'">
                  </app-select-dropdown>
                </div>
              </div>
              <div class="row pt-2 pb-2  vertical-align">
                <div class="col-4">
                  <span i18n="finder_admin|@@probability" class="title">Probabilité </span>
                </div>
                <div class="col-4">
                  <form>
                    <div class="input-group " *ngIf="finderData.admin.probalityDamage">
                      <input (change)="onChange($event)" type="number" min="0" max="99" placeholder="2"
                        [(ngModel)]="finderData.admin.probalityDamage.min" [ngModelOptions]="{standalone: true}">
                      <div class="input-group-append">
                        <span class="input-group-text" id="basic-addon2">% min</span>
                      </div>
                    </div>
                  </form>
                </div>
                <div class="col-4">
                  <form>
                    <div class="input-group " *ngIf="finderData.admin.probalityDamage">
                      <input (change)="onChange($event)" type="number" min="1" max="100" placeholder="100%"
                        [(ngModel)]="finderData.admin.probalityDamage.max" [ngModelOptions]="{standalone: true}">
                      <div class="input-group-append">
                        <span class="input-group-text" id="basic-addon2">% max</span>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div class="row pt-2 pb-2  vertical-align">
              <div class="col-10"></div>
              <div class="col-2">
                <button type="button" class="btn btn-lg btn-primary" (click)='validate()'>
                  Valider</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <tag-input (focus)="focusInput(true)" (blur)="focusInput(false)" [ngModel]="finderData.admin.searchTags"
        (ngModelChange)="updateSearchTagsAdmin($event)" (onRemove)="removeSearchTagsAdmin(false, $event)"
        [removable]='true' [hideForm]='true' theme='bootstrap'>
      </tag-input>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/element/finder-admin/finder-admin.component.html